<template>
    <DxDataGrid :hover-state-enabled="true" :show-borders="false" :data-source="props.projects" id="userProjectGridContainer"
        :auto-navigate-to-focused-row="false">
        <DxFilterRow :visible="true" />
        <DxStateStoring :enabled="true" type="localStorage" storage-key="userProjectGridContainer" />
        <DxHeaderFilter :visible="true" />
        <DxColumn data-field="project.projectName" data-type="string" caption="Project name" />
        <DxColumn data-field="project.projectNumber" data-type="string" caption="Project number" />
        <DxColumn data-field="project.service.blServiceName" data-type="string" caption="Service" />
        <DxColumn data-field="project.projectType" data-type="string" caption="Project type" />
        <DxColumn data-field="participationFrom" data-type="date" caption="From" format="dd/MM/yyyy"/>
        <DxColumn data-field="participationTo" data-type="date" caption="To" format="dd/MM/yyyy" />
        <DxColumn data-field="project.isActive" data-type="boolean" caption="Active" :allow-header-filtering="false" :allow-filtering="true" />
        <DxPaging :page-size="10" />
    </DxDataGrid>
</template>
  
<script setup lang="ts">
import DxDataGrid, {
    DxColumn,
    DxFilterRow,
    DxStateStoring,
    DxPaging,
    DxHeaderFilter,
} from "devextreme-vue/data-grid";
import { UserProjectShowItem } from "@/services/entities/UserProjectItem";

const emit = defineEmits(["detail"]);

const props = defineProps({
    projects: { Type: [] as UserProjectShowItem[], default: [] as UserProjectShowItem[] },
});
</script>
  
<style scoped lang="scss"></style>